import {DataObjectId} from 'yougile-model'
import {SortState} from '@components/common/base/sort/sort'
import {Sort, TableDataType, TableRow, TableSortState} from './types'

export const tableSortToState = (
  sort: Sort | undefined,
  i: number
): TableSortState => {
  if (!sort || sort.columnIndex !== i) {
    return 'no'
  }
  return sort?.order ? 'down' : 'up'
}

export const tableSortStateToSort = (
  tableSortState: TableSortState
): SortState => {
  if (tableSortState === 'up') {
    return 'up'
  }

  if (tableSortState === 'down') {
    return 'down'
  }

  return 'default'
}

export const findRowPathById = <T extends TableDataType>(
  rows: TableRow<T>[],
  rowId: DataObjectId | string,
  path = ''
): string | null => {
  for (const [rowIndex, rowItem] of rows.entries()) {
    const currentPath =
      path === '' ? rowIndex.toString() : `${path}.${rowIndex}`

    if (rowItem.data.id === rowId) {
      return currentPath
    }

    if (rowItem.subRows?.length) {
      const childPath = findRowPathById(rowItem.subRows, rowId, currentPath)
      if (childPath !== null) {
        return childPath
      }
    }
  }

  return null
}
